module.exports = __webpack_public_path__ + "img/case12-jpg.56d33a19.jpg";